export const COOKIE_POLICY_PLACEHOLDER = '{{InsertCookiePolicy}}';

interface RichTextLike {
  content?: RichTextLike[];
  marks?: Array<{ type: string }>;
  nodeType?: string;
  value?: string;
}

/**
 * Returns true when the Contentful Rich Text document contains any formatting
 * beyond a single plain-text paragraph (e.g. marks, multiple blocks, headings,
 * lists, blockquotes) or the cookie policy placeholder, which only the Rich
 * Text renderer can replace. Used to decide whether to render the full Rich
 * Text renderer or fall back to a plain <p> string.
 */
export const isRichTextFormatted = (doc: unknown): boolean => {
  const d = doc as RichTextLike | null | undefined;
  if (!d?.content || d.content.length === 0) return false;
  if (d.content.length > 1) return true;

  const hasNonParagraph = d.content.some((node) => node.nodeType !== 'paragraph');
  if (hasNonParagraph) return true;

  const needsRenderer = (node: RichTextLike): boolean => {
    if (node.nodeType === 'text') {
      return (
        (node.marks?.length ?? 0) > 0 || Boolean(node.value?.includes(COOKIE_POLICY_PLACEHOLDER))
      );
    }
    return node.content?.some(needsRenderer) ?? false;
  };

  return d.content.some(needsRenderer);
};
